import React, { useState, useEffect } from "react";
import auth from "services/auth";
import { Redirect, Route, Link, useLocation } from "react-router-dom";
import Translator, { __ } from "services/Translator";
// import {
//   FaHome,
//   FaGift,
//   FaFutbol,
//   FaDice,
//   FaRegPlayCircle,
// } from "react-icons/fa";

const StickyFooterMenu = (props) => {
  const [isAuthenticated, setIsAuthenticated] = useState(auth.isAuthenticated);
  const [showWalletModal, setShowWalletModal] = useState(false);
  useEffect(() => {
    // alert(showWalletModal)
    if (showWalletModal == true) {
      props.showWalletModal(showWalletModal);
    }
  }, [showWalletModal]);

  const handleChatToggle = () => {
    if (typeof window.Tawk_API !== "undefined") {
      window.Tawk_API.toggle();
    } else {
      console.error("Tawk_API is not available.");
    }
  };
  //Search functionality
  const [showSearch, setShowSearch] = useState(false);
  const [searchVal, setSearchVal] = useState("");
  const updateSearchInput = (ev) => {
    var target = ev.target;
    var field = target.name;
    var value = target.value;
    setSearchVal(value);
  };

  // useEffect(() => {
  //   props.searchVal(searchVal);
  // }, [searchVal]);

  //GamePlay Page detection
  const location = useLocation();

  const [showSlotsLink, setShowSlotsLink] = useState(false);

  useEffect(() => {
    const playPath = location.pathname.split("/");
    setShowSlotsLink(playPath.includes("live-casino"));
  }, [location]);

  return (
    <>
      <div className="sticky_footer_menu_area d-none">
        {/*
      <div className={"sticky_search_area " + (showSearch ? "showSearch" : '')} >
        <input onChange={updateSearchInput} name="search_value" value={searchVal} type="text" />
      </div>
      */}
        <ul>
          {!isAuthenticated && (
            <li>
              <Link hrefLang={Translator.getSelectedLanguage().code} to="/">
                <i class="fas fa-home"></i>
                <div className="menu_text">{__("Home")}</div>
              </Link>
            </li>
          )}
          {isAuthenticated && (
            <li>
              <Link
                hrefLang={Translator.getSelectedLanguage().code}
                onClick={() => props.setOpenWalletModalTab("deposit")}
              >
                <i class="fas fa-wallet"></i>
                <div className="menu_text">{__("Wallet")}</div>
              </Link>
            </li>
          )}

          <li>
            <Link
              hrefLang={Translator.getSelectedLanguage().code}
              to={{ pathname: "/", state: { focusSearch: true } }}
            >
              <i class="fas fa-search"></i>
              <div className="menu_text">{__("Search")}</div>
            </Link>
          </li>

          {showSlotsLink ? (
            <li>
              <Link
                hrefLang={Translator.getSelectedLanguage().code}
                to={{ pathname: "/games/slots" }}
              >
                <svg className="svg_icon">
                  <use
                    xlinkHref={
                      require("assets/images/common/game_icons/game_icons.svg")
                        .default + "#slots"
                    }
                  />
                </svg>
                <div className="menu_text">{__("Slots")}</div>
              </Link>
            </li>
          ) : (
            <li>
              <Link
                hrefLang={Translator.getSelectedLanguage().code}
                to={{ pathname: "/games/live-casino" }}
              >
                <svg className="svg_icon">
                  <use
                    xlinkHref={
                      require("assets/images/common/game_icons/game_icons.svg")
                        .default + "#live_casino"
                    }
                  />
                </svg>
                <div className="menu_text">{__("Live")}</div>
              </Link>
            </li>
          )}

          <li>
            <Link
              hrefLang={Translator.getSelectedLanguage().code}
              onClick={() => {
                handleChatToggle();
              }}
            >
              <i class="far fa-comment-dots"></i>
              <div className="menu_text">{__("Support")}</div>
            </Link>
          </li>
        </ul>
      </div>
      <section className={"stickyMenu " + props.className}>
        <div className="nav-bar">
          <Link
            to="/"
            className={"nav-item " + (location.pathname == "/" ? "active" : "")}
          >
            <div className="icon">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.5702 6.95923C15.5698 6.95886 15.5695 6.9585 15.5691 6.95813L9.04171 0.431641C8.76348 0.15332 8.39357 0 8.0001 0C7.60663 0 7.23672 0.153198 6.95837 0.431519L0.434387 6.95471C0.432189 6.95691 0.429992 6.95923 0.427794 6.96143C-0.143553 7.53601 -0.142576 8.46826 0.430602 9.04138C0.69247 9.30334 1.03833 9.45508 1.40812 9.47095C1.42314 9.47241 1.43827 9.47314 1.45353 9.47314H1.71369V14.2762C1.71369 15.2267 2.48709 16 3.43787 16H5.99159C6.25041 16 6.46039 15.7902 6.46039 15.5312V11.7656C6.46039 11.3319 6.81321 10.9791 7.24697 10.9791H8.75323C9.18699 10.9791 9.53981 11.3319 9.53981 11.7656V15.5312C9.53981 15.7902 9.74967 16 10.0086 16H12.5623C13.5131 16 14.2865 15.2267 14.2865 14.2762V9.47314H14.5277C14.9211 9.47314 15.291 9.31995 15.5695 9.04163C16.1433 8.46753 16.1435 7.53369 15.5702 6.95923Z"
                  fill="white"
                />
              </svg>
            </div>
            <span>Home</span>
          </Link>
          <Link
            to="/games/all"
            className={
              "nav-item " + (location.pathname == "/games/all" ? "active" : "")
            }
          >
            <div className="icon">
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.7573 14H3.48543C3.25891 14 3.07527 13.8164 3.07527 13.5898C3.07527 9.4684 5.34551 7.63514 7.58866 5.392L8.69662 4.28403C8.4391 4.31788 8.16632 4.33486 7.87869 4.33486C6.72454 4.33486 5.72805 3.89555 4.80342 3.89555C3.81836 3.89555 3.01695 4.69697 3.01695 5.682C3.01695 5.90852 2.8333 6.09216 2.60679 6.09216H0.410156C0.183641 6.09216 0 5.90852 0 5.682V0.410156C0 0.183641 0.183641 0 0.410156 0H2.60676C2.83328 0 3.01692 0.183641 3.01692 0.410156V0.871719C3.87379 0.31109 4.96281 0 6.12134 0C7.96173 0 8.84885 0.878664 10.5146 0.878664C10.7729 0.878664 10.9831 0.668473 10.9831 0.410156C10.9831 0.183641 11.1667 0 11.3932 0H13.5898C13.8164 0 14 0.183641 14 0.410156C14 2.44423 13.0222 3.86982 11.987 5.37917C10.6654 7.30614 9.16746 9.49022 9.16746 13.5898C9.16746 13.8164 8.98382 14 8.7573 14Z"
                  fill="white"
                />
              </svg>
            </div>
            <span>Casino</span>
          </Link>
          <Link
            to="/sports"
            className={
              "nav-item " + (location.pathname == "/sports" ? "active" : "")
            }
          >
            <div className="icon">
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7 0C3.14038 0 0 3.14038 0 7C0 10.8596 3.14038 14 7 14C10.8596 14 14 10.8596 14 7C14 3.14038 10.8596 0 7 0ZM7.4445 2.27413L9.24437 1.30638C10.241 1.701 11.1108 2.34763 11.7723 3.17013L11.3435 5.14937L9.97062 5.82225L7.4445 3.98213V2.27413ZM4.7705 1.30113L6.57037 2.27237V3.98213L4.046 5.82225L2.66612 5.1485L2.23738 3.157C2.90062 2.33625 3.77213 1.69313 4.7705 1.30113ZM1.95125 10.4598C1.37988 9.6285 1.008 8.65112 0.905625 7.595L2.387 5.98588L3.738 6.6465L4.75562 9.53662L3.8955 10.5674L1.95125 10.4598ZM8.56013 12.9159C8.0605 13.048 7.53988 13.125 7 13.125C6.34725 13.125 5.719 13.02 5.12838 12.8301L4.578 11.1169L5.45563 10.0625H8.54788L9.40975 11.0828L8.56013 12.9159ZM10.0923 10.5376L9.24613 9.53575L10.2778 6.6465L11.6226 5.98763L13.0952 7.59587C13.0069 8.50675 12.7137 9.35637 12.2684 10.108L10.0923 10.5376Z"
                  fill="white"
                />
              </svg>
            </div>
            <span>Sports</span>
          </Link>
          <Link
            to="/games/live-casino"
            className={
              "nav-item " +
              (location.pathname == "/games/live-casino" ? "active" : "")
            }
          >
            <div className="icon">
              <svg
                width="13"
                height="14"
                viewBox="0 0 13 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.3038 7.30428C12.3165 5.29118 10.8104 4.30932 9.48084 3.44368L9.46498 3.43335C9.17486 3.24366 8.90136 3.06435 8.65911 2.88379C7.49963 2.01479 6.48472 0.655038 6.3661 0.162848C6.34218 0.0667416 6.25894 0.00324494 6.14853 0C6.07021 0.0063697 5.97975 0.0578481 5.95295 0.156358C5.81775 0.645183 4.93192 1.96595 3.65153 2.85375C3.44705 2.99592 3.2268 3.13485 2.97229 3.2959C1.64211 4.1381 -0.013656 5.18682 8.49611e-05 7.2788C0.01655 9.86719 1.59063 11.0454 3.04556 11.0454C3.99216 11.0454 4.91325 10.5797 5.59284 9.76183C5.29972 11.1652 4.40628 12.9095 1.86488 13.5804C1.76217 13.6079 1.69483 13.7089 1.70745 13.8145C1.72151 13.9204 1.81281 14 1.91997 14H10.3875C10.5058 14 10.6009 13.9047 10.6009 13.7866C10.6009 13.6832 10.5244 13.5896 10.4368 13.5795C10.3254 13.5458 7.74228 12.7392 6.8522 9.83209C7.52531 10.5434 8.4137 10.9482 9.31215 10.949C10.79 10.949 12.2867 9.82172 12.3038 7.30428Z"
                  fill="rgba(255, 255, 255, 0.3)"
                />
              </svg>
            </div>
            <span>Live</span>
          </Link>
          <Link
            to="/promotions"
            className={
              "nav-item " + (location.pathname == "/promotions" ? "active" : "")
            }
          >
            <div className="icon">
              <svg
                width="15"
                height="14"
                viewBox="0 0 15 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.93457 7.45825V13.0655C0.93457 13.5813 1.35418 14 1.8691 14H6.54177V7.45825H0.93457Z"
                  fill="white"
                />
                <path
                  d="M14.018 3.72014H11.0611C11.2733 3.57529 11.4555 3.43137 11.5826 3.30241C12.3368 2.5445 12.3368 1.31092 11.5826 0.55301C10.8499 -0.185271 9.57336 -0.183402 8.84162 0.55301C8.43603 0.959532 7.36132 2.61459 7.50991 3.72014H7.44262C7.59028 2.61459 6.51557 0.959532 6.11091 0.55301C5.37824 -0.183402 4.10167 -0.183402 3.36993 0.55301C2.61669 1.31092 2.61669 2.5445 3.36899 3.30241C3.49702 3.43137 3.67926 3.57529 3.8914 3.72014H0.934533C0.419605 3.72014 0 4.13975 0 4.65468V6.05648C0 6.31441 0.209335 6.52374 0.467267 6.52374H6.54173V4.65468H8.4108V6.52374H14.4853C14.7432 6.52374 14.9525 6.31441 14.9525 6.05648V4.65468C14.9525 4.13975 14.5339 3.72014 14.018 3.72014ZM6.4866 3.6893C6.4866 3.6893 6.44735 3.72014 6.31371 3.72014C5.66794 3.72014 4.4353 3.04915 4.03251 2.64356C3.64094 2.24919 3.64094 1.60623 4.03251 1.21186C4.22222 1.02121 4.47361 0.916544 4.74089 0.916544C5.00723 0.916544 5.25862 1.02121 5.44833 1.21186C6.07821 1.84547 6.70434 3.46408 6.4866 3.6893ZM8.63789 3.72014C8.50519 3.72014 8.46594 3.69024 8.46594 3.6893C8.24819 3.46408 8.87433 1.84547 9.5042 1.21186C9.88082 0.831501 10.5397 0.829632 10.92 1.21186C11.3125 1.60623 11.3125 2.24919 10.92 2.64356C10.5172 3.04915 9.28459 3.72014 8.63789 3.72014Z"
                  fill="white"
                />
                <path
                  d="M8.41077 7.45825V14H13.0834C13.5993 14 14.018 13.5813 14.018 13.0655V7.45825H8.41077Z"
                  fill="white"
                />
              </svg>
            </div>
            <span>Bonuses</span>
          </Link>
        </div>
      </section>
    </>
  );
};

export default StickyFooterMenu;
